export const IRSReason = {
  name: "irs-reason",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "irs.reason",
  showOn: [{ state: "primary", value: "irs-reason", operator: "is" }],
  allowCancel: true,
  children: [
    {
      name: "irs-reason-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        optionName: "reason",
        layout: "type-button",
        prefix: "reason",
        children: [
          "period_end",
          "clock_correction",
          "shot_clock_violation",
          "non_shooting_foul",
          "goaltending",
          "out_of_bounds",
          "field_goal_success",
          "free_throws_shooting_foul",
          "foul_change",
          "identify_ft_shooter",
          "violence",
        ],
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "nextState", value: "irs-decision", type: "primary" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
